var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-2"},[_c('v-card-title',[_vm._v("修改供應商")]),_c('v-card-text',[_c('v-divider'),_c('merchant-form',_vm._b({attrs:{"loading":_vm.loading},on:{"submit":_vm.submit}},'merchant-form',_vm.form,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }